import { useCallback, useMemo } from 'react';
import type { PortalLocale } from './constants';
import { getStoredPortalLocale } from './portalLocaleEvents';
import { setPortalLocale } from './I18nProvider';
import { useLocaleTick } from './localeTick';

const ARIA = { ko: '언어', en: 'Language' } as const;

export function PortalLanguageToggle() {
  const tick = useLocaleTick();
  const locale = useMemo(() => getStoredPortalLocale(), [tick]);

  const setLocale = useCallback((next: PortalLocale) => {
    void setPortalLocale(next);
  }, []);

  const aria = ARIA[locale];

  return (
    <div
      className="flex items-center gap-1 rounded-lg border border-slate-200/80 bg-white/80 p-0.5 text-xs font-medium shadow-sm"
      role="group"
      aria-label={aria}
    >
      {(['ko', 'en'] as const).map((opt) => {
        const active = locale === opt;
        const label = opt === 'ko' ? '한국어' : 'English';
        return (
          <button
            key={opt}
            type="button"
            onClick={() => setLocale(opt)}
            className={`rounded-md px-2.5 py-1 transition-colors ${
              active
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-slate-600 hover:bg-slate-100'
            }`}
            aria-pressed={active}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
